<style lang="stylus">
    .pcview-publishFile
        display flex
        flex-direction column
        position relative
        height 100%
        padding 0 0 0 24px
        user-select none
        .files-title
            height 40px
            display flex
            justify-content space-between
            align-items center
            padding-right 40px
            white-space nowrap
            pointer-events none
            .files-path
                position absolute
                color #000
                font-size 18px
                display flex
                top 0

                div
                    margin-right 4px
                    max-width 200px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    cursor pointer
                    pointer-events auto
            .back
                margin-top 80px
        .searchMarginT
            margin-top 40px
        .files-right
            .files-button-box
                display flex
                align-items center
                outline none
                border none
                pointer-events auto
                user-select: none;
                margin-left 14px
                font-size: 12px;
                border-radius: 6px;
                line-height 28px
                height 28px;
                padding: 0px
                cursor pointer
                background-color initial
                transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear,-webkit-box-shadow .2s linear;
                >svg
                    fill #424242
                    stroke #424242
                    width 28px
                    height 28px
                &:hover
                    background-color: rgba(0, 0, 0, 4%);
                &:active
                    background-color: rgba(0, 0, 0, 6%);
            @media screen and (max-width: 1200px)
                display none
        .emptyCloud
            font-size 13px
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -157px)
            span
                color #222
        .pcview-publishFile-list-header
            >div
                cursor default
                display flex
                align-items center
                white-space nowrap
                font-size 14px
                &:hover
                    background-color unset

            .file-name
                width 36%
            .file-time
                width 45.5%
            .file-used
                width 18.5%
        .files-search-box
            input
                &:focus
                    border-color var(--themeColor)
                    box-shadow unset

    .ivu-dropdown
        .ivu-dropdown-rel
            a:focus,a:hover
                color var(--themeColor)!important
</style>

<template>
    <div class="pcview-publishFile" :class="{ 'dark-theme_pcview__files': isPCDarkMode == 2, 'dialog-view': isDialog }" @click="clear()">
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClick($event)"
        />
        <FileNum v-if="isPC" />

        <div v-if="layoutMode == 'list' && !searchMode" class="pcview-list-header pcview-publishFile-list-header">
            <div class="file-name" @click="clickOrder('name')">
                <span>{{ $t("name") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'name' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'name' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-time" @click="clickOrder('time')">
                <span>{{ $t("time") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'time' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'time' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-used" @click="clickOrder('used')">
                <span>{{ $t("used") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'used' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'used' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
        </div>

        <div class="pcview-files-scroll" @scroll="clear" @click="clearFile" ref="filesScroll">
            <template v-if="layoutMode == 'grid'">
                <div class="files-box" ref="filesBoxList">
                    <gridFile v-for="(item, index) in searchMode ? searchList : filesList" :key="index" :type="type" :index="index" :file="item" />
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in searchMode ? searchList : filesList"
                            :key="index"
                            :type="type"
                            :mode="searchMode ? 'search' : 'publishFile'"
                            :index="index"
                            :file="item"
                        />
                    </div>
                </div>
            </template>
            <div class="emptyCloud" v-cloak v-if="userInfo && !pcNoLogin && filesList && filesList.length == 0 && !showLoading">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>
            <pclogin />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "../fileItem";
    import naturalsort from "javascript-natural-sort";
    import listFile from "./listFile.vue";
    import gridFile from "../gridFile.vue";
    import RightMenu from "../RightMenu.vue";
    import pclogin from "@/home/parts/pclogin.vue";
    import appConfig from "@/public/globalConfig";
    import FileNum from "./parts/fileNum.vue";
    naturalsort.insensitive = true;

    @Component({
        components: {
            listFile,
            gridFile,
            pclogin,
            RightMenu,
            FileNum,
        },
    })
    export default class WbpublishFile extends Mixins(fileItem) {
        filesList = [];
        searchList = [];
        searchValue = "";
        orderName = "time";
        rotate = 0;
        deleteFlag = false;
        type = "publishFile";
        isBuild = appConfig.isBuild;

        get searchMode() {
            return this.$store.state.publish.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setPublishStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }

        get menuList() {
            let list = [
                { label: this.$t("openPublish"), ban: this.fileSelected.length > 1 },
                { label: this.$t("updatePublish"), ban: this.fileSelected.length > 1 },
                {
                    label: this.$t("cancelPublish"),
                    hide: !this.isBuild,
                    ban: this.fileSelected.length > 1,
                },
            ];
            return list.filter((i) => (i.hasOwnProperty("hide") ? i.hide : true));
        }
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUserLogin();
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        @Watch("userInfo.islogin")
        onLoginChanged(val, oldval) {
            if (this.isPC) {
                if (val && !oldval) {
                    this.getList();
                    this.$bus.$emit("pcLoginEvenvt");
                } else if (!val && oldval) {
                    this.filesList = [];
                    this.searchList = [];
                }
            }
        }

        get showLoading() {
            return this.$store.state.showLoading;
        }
        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }

        mounted() {
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.fileSelected.length == 1 &&
                            this.openFiles(this.searchValue ? this.searchList[this.fileSelected[0]] : this.filesList[this.fileSelected[0]]);
                    },
                ],
                [
                    1,
                    () => {
                        this.fileSelected.length == 1 &&
                            this.openFiles(
                                this.searchValue ? this.searchList[this.fileSelected[0]] : this.filesList[this.fileSelected[0]],
                                "publish"
                            );
                    },
                ],
                [
                    2,
                    () => {
                        this.fileSelected.length == 1 && this.deleteWork();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
        }
        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
        }
        clearFile() {
            this.selectFilesIndex = [];
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            if (this.searchValue) {
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    if (item.title.toLowerCase().includes(this.searchValue.toLowerCase())) {
                        let filePath = item.obj.match(/[^\/]+\/[^\/]+\/(.+)/) && item.obj.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        item.filePath = filePath;
                        item.info = {
                            edit: item.edit,
                            custom_tag: item.custom_tag,
                        };
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        created() {
            this.isPC && this.$store.commit("setState", { data: 12, type: "selectId" });
            this.$bus.$on("refreshPublishFile", () => {
                this.getList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getList();
            } else {
                this.$bus.$on("loginSucc-publish", () => {
                    this.getList();
                });
            }
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        getList() {
            this.filesList = [];
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let obj = {
                id: this.params.id,
                token: this.params.token,
                status: "ALL",
                is_contain_edt: "0",
            };
            this.$edApi
                .getUserPublishWorks(obj)
                .then((list) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    let arr = list;
                    arr.map((item) => {
                        item.info = {
                            edit: item.edit,
                            custom_tag: item.custom_tag,
                        };
                        return item;
                    });
                    arr.sort((a, b) => {
                        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                    });
                    console.log(arr, this.type);
                    this.filesList = arr;
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        loadErr(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        contextmenu(e, files, index) {}

        deleteWork() {
            // 取消发布
            this.$Modal.confirm({
                title: <string>this.$t("cancelPublish") + " ?",
                okText: <string>this.$t("okText"),
                cancelText: <string>this.$t("cancelText"),
                closable: true,
                loading: true,
                onOk: () => {
                    this.$Modal.remove();
                    this.deletePublishFile();
                },
            });
        }
        deletePublishFile() {
            if (this.deleteFlag) {
                return;
            }
            this.deleteFlag = true;
            let item = this.searchMode ? this.searchList[this.fileSelected[0]] : this.filesList[this.fileSelected[0]];
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                workId: item.id,
            };
            this.$edApi
                .deletePublish(params)
                .then(() => {
                    //删除成功之后关闭窗口
                    this.deleteFlag = false;
                    this.$edMessage.success(this.$t("cancelSuccess"));
                    let list = this.searchMode ? this.searchList : this.filesList;
                    for (let i = 0; i < list.length; i++) {
                        if (item.id == list[i].id) {
                            list.splice(i, 1);
                            break;
                        }
                    }
                    this.clearFile();
                })
                .catch(() => {
                    this.deleteFlag = false;
                });
        }

        setLayout() {
            this.$store.commit("changeLayout");
            this.clearFile();
        }

        clickOrder(name) {
            this.$track("files", "sort by", name);
            const change = this.orderName !== name;
            this.$bus.$emit("listHeadOrder", {
                sort: name,
                order: change ? this.rotate : this.rotate == 0 ? 180 : 0,
            });
        }

        setOrder(name) {
            this.orderName = name;
            if (name === "time") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                }
            } else if (name === "used") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => a.used - b.used);
                } else {
                    this.filesList = this.filesList.sort((a, b) => a.used - b.used).reverse();
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.title, b.title));
                } else {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.title, a.title));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                }
            }
        }

        order() {
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.title, a.title));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                } else if (this.orderName == "used") {
                    this.filesList = this.filesList.sort((a, b) => a.used - b.used);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.title, b.title));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                } else if (this.orderName == "used") {
                    this.filesList = this.filesList.sort((a, b) => a.used - b.used).reverse();
                }
            }
        }

        beforeDestroy() {
            this.selectFilesIndex = [];
            this.contextmenuBoxShow = false;
            this.$bus.$off("refreshPublishFile");
            this.$bus.$off("loginSucc-publish");
        }
    }
</script>
<i18n>
{
  "zh": {
    "name": "文件名",
    "time": "发布时间",
    "used": "使用量",
    "search": "搜索文件",
    "return": "返回",
    "notTem": "暂时没有发布文件哦~",
    "notFind": "没有找到相应文件",
    "title": "我的发布",
    "openPublish": "打开",
    "cancelPublish": "取消发布",
    "updatePublish": "更新发布信息",
    "cancelSuccess": "取消发布成功！",
    "switchView": "切换视图",
    "okText": "确定",
    "personal": "个人云",
    "cancelText": "取消"
  },
  "en": {
    "name": "File name",
    "time": "Release time",
    "used": "Usage amount",
    "search": "Search file",
    "return": "Return",
    "notTem": "No documents released",
    "notFind": "Not Find",
    "title": "Publish",
    "openPublish": "Open",
    "cancelPublish": "Cancel publication",
    "updatePublish": "Update template information",
    "cancelSuccess": "Cancel publication successfully!",
    "switchView": "Switch View",
    "okText": "OK",
    "personal": "Personal",
    "cancelText": "Cancel"
  },
  "fr": {
    "name": "nom de fichier",
    "time": "Délai de sortie",
    "used": "Montant d'utilisation",
    "search": "Rechercher un fichier",
    "return": "retour",
    "notTem": "Aucun document publié",
    "notFind": "Aucun fichier correspondant trouvé",
    "title": "Publier",
    "openPublish": "allumer",
    "cancelPublish": "Annuler la publication",
    "updatePublish": "Mettre à jour les informations du modèle",
    "cancelSuccess": "Publication annulée avec succès !",
    "switchView": "Changer de vue",
    "okText": "Créer",
    "personal": "Cloud personnel",
    "cancelText": "Annuler"
  },
  "de": {
    "name": "Dateiname",
    "time": "Veröffentlichungsdatum",
    "used": "Nutzungsmenge",
    "search": "Datei durchsuchen",
    "return": "Rückkehr",
    "notTem": "Keine Dokumente freigegeben",
    "notFind": "Keine entsprechende Datei gefunden",
    "title": "Veröffentlichen",
    "openPublish": "anschalten",
    "cancelPublish": "Publikation abbrechen",
    "updatePublish": "Vorlageninformationen aktualisieren",
    "cancelSuccess": "Veröffentlichung erfolgreich abgebrochen!",
    "switchView": "Ansicht wechseln",
    "okText": "Sichern",
    "personal": "Persönlicher Cloud",
    "cancelText": "Abbrechen"
  },
  "jp": {
    "name": "ファイル名",
    "time": "更新日時",
    "used": "使用量",
    "search": "ファイルを検索",
    "return": "戻る",
    "notTem": "投稿したファイルはまだありません",
    "notFind": "該当するファイルは見つかりませんでした",
    "title": "投稿",
    "openPublish": "開く",
    "cancelPublish": "投稿をキャンセルする",
    "updatePublish": "テンプレート情報を更新する",
    "cancelSuccess": "正常にキャンセルしました",
    "switchView": "ビューを切り替える",
    "okText": "OK",
    "personal": "個人クラウド",
    "cancelText": "キャンセル"
  },
  "es": {
    "name": "nombre del archivo",
    "time": "Tiempo de liberación",
    "used": "Cantidad de uso",
    "search": "Archivo de búsqueda",
    "return": "regreso",
    "notTem": "No se publicaron documentos",
    "notFind": "No encontrar",
    "title": "Publicar",
    "openPublish": "encender",
    "cancelPublish": "Cancelar publicación",
    "updatePublish": "Actualizar información de la plantilla",
    "cancelSuccess": "¡Publicación cancelada exitosamente!",
    "switchView": "Cambiar vista",
    "okText": "Confirmar",
    "personal": "Nube Personal",
    "cancelText": "Cancelar"
  },
  "pt": {
    "name": "nome do arquivo",
    "time": "Tempo de lançamento",
    "used": "Quantidade de uso",
    "search": "Pesquisar arquivo",
    "notTem": "Nenhum documento liberado",
    "return": "Retorna",
    "notFind": "Não Encontrado",
    "title": "Publicar",
    "openPublish": "Ligar",
    "cancelPublish": "Cancelar publicação",
    "updatePublish": "Atualizar informações do modelo",
    "cancelSuccess": "Publicação cancelada com sucesso!",
    "switchView": "Trocar Visualização",
    "okText": "OK",
    "personal": "Pessoal",
    "cancelText": "Cancelar"
  },
  "it": {
    "name": "nome del file",
    "time": "Tempo di rilascio",
    "used": "Importo di utilizzo",
    "search": "Cerca file",
    "return": "ritorno",
    "notTem": "Nessun documento rilasciato",
    "notFind": "Nessun file corrispondente trovato",
    "title": "Pubblicare",
    "openPublish": "accendere",
    "cancelPublish": "Annulla pubblicazione",
    "updatePublish": "Aggiorna le informazioni sul modello",
    "cancelSuccess": "Pubblicazione annullata con successo！",
    "switchView": "Cambia Vista",
    "okText": "OK",
    "personal": "Personali",
    "cancelText": "Annulla"
  },
  "tw": {
    "name": "檔案名",
    "used": "使用量",
    "time": "發佈時間",
    "search": "搜尋檔案",
    "notTem": "沒有發布檔案",
    "return": "返回",
    "notFind": "沒有找到相應檔案",
    "title": "發佈",
    "openPublish": "打開",
    "cancelPublish": "取消發佈",
    "updatePublish": "更新發佈信息",
    "cancelSuccess": "取消發佈成功！",
    "switchView": "切換視圖",
    "okText": "取消",
    "personal": "個人雲端硬碟",
    "cancelText": "確定"
  },
  "kr": {
    "name": "파일 이름",
    "time": "배포시간",
    "used": "사용수",
    "search": "파일 검색",
    "return": "돌아가기",
    "notTem": "아직 게시한 파일이 없습니다~",
    "notFind": "해당 파일을 찾지 못했습니다",
    "title": "게시",
    "openPublish": "열기",
    "cancelPublish": "게시 취소",
    "updatePublish": "게시 정보 업데이트",
    "cancelSuccess": "게시 취소 성공!",
    "switchView": "보기 전환",
    "okText": "확인",
    "personal": "개인 클라우드",
    "cancelText": "취소"
  },
  "id": {
    "name": "Nama file",
    "time": "Waktu rilis",
    "used": "Jumlah penggunaan",
    "search": "Cari file",
    "return": "Kembali",
    "notTem": "Tidak ada dokumen yang dirilis",
    "notFind": "Tidak Menemukan",
    "title": "Terbitkan",
    "openPublish": "Buka",
    "cancelPublish": "Batalkan publikasi",
    "updatePublish": "Perbarui informasi templat",
    "cancelSuccess": "Publikasi berhasil dibatalkan!",
    "switchView": "Ganti Tampilan",
    "okText": "OKE",
    "personal": "Personal",
    "cancelText": "Batalkan"
  }
}
</i18n>
